import EnemyProjectileLogic from "./EnemyProjectileLogic";
import Physics from "./Physics";

class MoonProjectileLogic extends EnemyProjectileLogic
{
    constructor()
    {
        super();

        this.startMoveIn = 4;
    }


    setSpawnDelay(delay)
    {
        this.spawnDelay = delay;
        this.startMoveIn = delay
    }


    postPhysicsUpdate(delta)
    {
        super.postPhysicsUpdate(delta);

        // this.startMoveIn -= delta;
        //
        // let p = this.entity.getComponent(Physics);

        // if (this.startMoveIn < 0)
        // {
        //     p.stopMove = false;
        //     // p.modifySize(delta, 0.7);
        // }

        // let p = this.entity.getComponent(Physics);
        //
        // this.startMoveIn -= delta;
        //
        // if (this.startMoveIn < 0)
        // {
        //     p.stopMove = false;
        //     p.modifySize(delta, 0.7);
        // }
        // else
        // {
        //     p.setSize(12 * (this.spawnDelay - this.startMoveIn)/this.spawnDelay)
        // }

    }
}

export default MoonProjectileLogic;